import { Field, FieldProps, withTypes } from "react-final-form";
import { Button, Grid } from "@mui/material";
import formSchemaValidator from "../formSchemaValidator";
import { FormSubmitCallback } from "../types";

export type customFieldProps = FieldProps<string, any> & {
    showIf?: (values: any) => boolean;
}
export type FormBaseProps<T> = {
    fields: customFieldProps[]
    initialValues?: T | {} | null,
    validationSchema: any,
    buttonSubmitLabel?: string,
    buttonCancelLabel?: string,
    readonly?: boolean,
    onSubmit?: FormSubmitCallback<T>
    onCancel?: (() => void) | null
}

export default function FormBase<T>({
    fields,
    initialValues,
    validationSchema,
    buttonSubmitLabel = "Save",
    buttonCancelLabel = "Cancel",
    readonly = false,
    onSubmit,
    onCancel
}: FormBaseProps<T>) {
    const { Form } = withTypes<T>()
    const noopSubmit: FormSubmitCallback<T> = () => { };

    return (
        <Form
            initialValues={initialValues ?? {}}
            validate={formSchemaValidator(validationSchema)}
            onSubmit={onSubmit ?? noopSubmit} render={({ form, submitting, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container style={{ marginTop: 0 }}>
                        {fields.map((field, i) => {
                            const currentValues = form.getState().values;
                            const isVisible = field.showIf ? field.showIf(currentValues) : true;

                            return field?.type === 'hidden'
                                ? (
                                    <Field
                                        key={`baseform-field-hidden-${i}`}
                                        name={field.name}
                                        autoComplete="off"
                                        type="hidden"
                                        defaultValue={field.value}
                                        component="input" />
                                )
                                : (
                                    <Grid key={`baseform-field-${i}`} container size={field.grid.xs} sx={{ visibility: isVisible ? "visible" : "hidden", paddingLeft: 1, paddingTop: 4 }}>
                                        <Field autoComplete="off" {...field} disabled={submitting || readonly} />
                                    </Grid>
                                )
                            // )
                        }
                        )}
                        <Grid size={12}
                            sx={{ paddingTop: 4, display: "flex", justifyContent: "flex-start" }}
                        >
                            {!readonly ? (
                                <Button
                                    disableElevation
                                    variant="contained"
                                    size="large"
                                    sx={{
                                        marginRight: "16px",
                                        backgroundColor: "#C4C4C4",
                                        "&:hover": {
                                            color: "#FFF",
                                            backgroundColor: "red.main",
                                        },
                                    }}
                                    onClick={onCancel!}
                                >
                                    {buttonCancelLabel}
                                </Button>
                            ) : null}
                            {!readonly ? (
                                <Button
                                    disabled={readonly}
                                    // loading={submitting}
                                    disableElevation
                                    variant="contained"
                                    size="large"
                                    type="submit"
                                    sx={{
                                        backgroundColor: "primary.main",
                                        "&:hover": {
                                            backgroundColor: "primary.light",
                                        },
                                    }}
                                >
                                    {buttonSubmitLabel}
                                </Button>
                            ) : null}

                        </Grid>
                    </Grid>
                </form>
            )}>

        </Form>
    )
}